const BASE_URL = process.env.VUE_APP_API_URL;

export default {
  BASE_URL,
  endpoints: {
    TOKEN: 'oauth2/token',
    OAUTH_AUTHORIZE: 'oauth2/authorize',
    OAUTH_TOKEN: 'oauth2/token',
    OAUTH_REFRESH: 'oauth2/refresh',
    OAUTH_LOGOUT: 'oauth2/logout',
    VERIFY_2FA: '/verify-2fa',
    CATEGORIES: 'category',
    OCCUPATION: 'occupations',
    OCCUPATION_ORDER: 'occu-order',
    CHILD_OCCUPATION_ORDER: 'child-occu-order',
    SET_OCCUPATION: 'set-occupations',
    LIST_OCCUPATION: 'list-occupation-selection',
    SUMMARY: 'summary',
    APPLICANTS: 'applicant/applicants',
    SCOUT_APPLICANTS: 'applicant/scout-applicant-list',
    PREVIEW_APPLICANT: 'applicant/preview-list',
    FIELD: 'field',
    PDFDOWNLOAD: (id) => `applicant/${id}/pdf?isNewPanel=true`,
    PREVIEW: (id, type) => `applicant/${id}/preview/${type}`,
    ALLAPPLICANTS: 'applicant/all-new-panel',
    FAVORITE: (id) => `applicant/${id}/favorite`,
    INTERVIEW: (id) => `applicant/${id}/interview`,
    SELECTORS: 'selectors',
    EVENTS: 'events',
    APPLICANT_PROFILE: (id) => `applicant/${id}`,
    FORGOT_PASSWORD: 'auth/forgot?isNewPanel=true',
    RESET_PASSWORD: (token) => `auth/reset/${token}`,
    SET_PASSWORD: (token) => `auth/set/${token}`,
    LOGOUT: 'auth/logout',
    GRAPH: 'dashboard',
    CHANGE_PASSWORD: 'auth/change_password',
    MONTLY_CHART_BY_REGISTRANT_STATUS: 'monthly-chart-by-registrants',
    MONTLY_CHART_BY_STATUS: 'monthly-chart-by-status',
    MONTLY_CHART_BY_REGISTRANTS: 'monthly-chart-by-registrant-status',
    MONTLY_CHART_BY_SHARED: 'monthly-chart-by-shared-registrants',
    MONTLY_CHART: 'monthly-chart',
    CLIENT_STATUS_CHANGE: (id) => `applicant/${id}/status`,
    CLIENT_MEMO: (id) => `applicant/${id}/memo`,
    CLIENT_COLOR_CHANGE: (id) => `applicant/${id}/color`,
    USERS: 'users',
    ALLUSERS: 'users/all-users',
    ASSIGNEDUSERS: 'users/scouted-by-users',
    REVIEW_LIST_USERS: 'users/review-list-users',
    REVIEW_LIST: 'review-list',
    EDIT_REVIEW_LIST: (id) => `review-list/edit/${id}`,
    DELETE_REVIEW_LIST: (id) => `review-list/${id}`,
    CREATE_REVIEW_LIST: 'review-list/create',
    UPDATE_REVIEW_LIST_ORDER: 'review-list/update-order',
    ASSIGN_TO_REVIEW_LIST: (id) => `applicant/${id}/reviewlist`,
    REMOVE_FROM_REVIEW_LIST: (id) => `applicant/${id}/reviewlist/remove`,
    REMOVE_FROM_REVIEW_LIST_MULTIPLE: 'applicant/multiple_review_list/remove',
    MULTIPLE_REVIEW_LIST: 'applicant/multiple_review_list',
    ASSIGNED_REVIEW_LIST: 'review-list/assigned',
    CHECK_ASSIGNED_REVIEW_LIST: `applicant/pending-review-list`,

    MULTIPLE_COLOR: 'applicant/multiple_color',
    REVIEW_LISTS: 'review-lists',
    CURRENTUSER: 'users/user',
    NOTIFICATION: (id) => `users/${id}/notification`,
    CREATEUSER: 'users/create',
    EDITUSER: (id) => `users/edit/${id}`,
    DELETEUSER: (id) => `users/${id}`,
    DEFAULT_SEARCH_TEMPLATE: 'users/default_search',
    MULTIPLE_STATUS: 'applicant/multiple_status',
    MULTIPLE_MEMO: 'applicant/multiple_memo',
    SAVE_SEARCH_TEMPLATE: 'search/save_search',
    CURRENTUSER_SEARCH_TEMPLATE: 'search/user_search_template',
    EDIT_TEMPLATE: (id) => `search/${id}`,
    TEMPLATE_STATUS_CHANGE: (id) => `search/${id}/default_change`,
    //individual contacts
    GET_MESSAGE_TEMPLATES: 'message-template',
    ADD_MESSAGE_TEMPLATE: 'message-template/create',
    REORDER_MESSAGE_TEMPLATE: 'message-template/reorder',
    EDIT_MESSAGE_TEMPLATE: (id) => `message-template/${id}`,
    DELETE_MESSAGE_TEMPLATE: (id) => `message-template/${id}`,
    DELETE_TEMPLATE: (id) => `search/${id}/delete_template`,
    MESSAGE_BY_JOBSEEKER: (id) => `contact/${id}`,
    DRAFT_MESSAGE: (id) => `contact/draft/${id}`,
    EDIT_DRAFT_MESSAGE: (id) => `contact/draft/edit/${id}`,
    SEND_MESSAGE_TO_JOBSEEKER: (id) => `contact/${id}`,
    SEND_DRAFT_MESSAGE_TO_JOBSEEKER: (id) => `contact/send-draft/${id}`,
    LIST_MESSAGES: 'contact',
    LIST_REPLIED_MESSAGES: 'contact/replied',
    REPLIED_MESSAGES_COUNT: 'contact/replied-count',
    TOGGLE_HIDE_MESSAGES: (id) => `contact/toggle-hide/${id}`,
    SITE_INFO: 'site-info',
    //jd_matching
    ALL_JDS: 'jd',
    PROFILE_JDS: 'jd/profile-jd',
    JD_BY_ID: (id) => `jd/${id}`,
    JD_MATCHING_LIST: (id) => `jd/matching-lists/${id}?isNewPanel=true`,
    MATCHING_BY_JD: (id) => `jd/matching/${id}`,
    MARK_JOBSEEKERS: (jdId) => `jd/mark-jobseeker/${jdId}`,
    MARK_JOBSEEKERS_MANUALLY: (jdId) => `jd/mark-jobseeker-manually/${jdId}`,
    MARK_MULTIPLE_JOBSEEKERS: (jdId) => `jd/mark-jobseeker-bulk/${jdId}`,
    MARK_INELIGIBLE: (jdId) => `jd/mark-ineligible/${jdId}`,
    UNSELECT_JOBSEEKER: (jdId, jobseekerId) =>
      `jd/unselect/${jdId}/${jobseekerId}`,
    USER_BASED_MATCHING: (jobseekerId) =>
      `jd/user-based-matching/${jobseekerId}`,
    SELECT_JD_STATUS: `jd/select-jd-status`,

    MARK_APPLICANT_READ: (id) => `users/${id}/jobseeker-read-status`,
    SCOUT_CHECK_UNCHECK: 'users/scout-check-uncheck',
    SCOUT_PERIOD_ENDED_CHECK_UNCHECK: 'users/scout-period-ending-display',
  },
  credentials: {
    CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
    CLIENT_SECRET: process.env.VUE_APP_CLIENT_SECRET,
    grantTypes: {
      PASSWORD: 'password',
      REFRESH_TOKEN: 'refresh_token',
    },
  },
};
